<template lang="html">
  <div :class="'season season'+0">
    <transition name="nils" mode="out-in">
      <Episode0 v-if="$route.params.episodeNumber == 0"></Episode0>
      <Episode1 v-if="$route.params.episodeNumber == 1"></Episode1>
      <Episode2 v-if="$route.params.episodeNumber == 2"></Episode2>
      <Episode3 v-if="$route.params.episodeNumber == 3"></Episode3>
      <Episode4 v-if="$route.params.episodeNumber == 4"></Episode4>
      <Episode5 v-if="$route.params.episodeNumber == 5"></Episode5>
      <Episode6 v-if="$route.params.episodeNumber == 6"></Episode6>
    </transition>
  </div>
</template>

<script>
import Episode0 from '@/components/season-2/episode-0.vue'
import Episode1 from '@/components/season-2/episode-1.vue'
import Episode2 from '@/components/season-2/episode-2.vue'
import Episode3 from '@/components/season-2/episode-3.vue'
import Episode4 from '@/components/season-2/episode-4.vue'
import Episode5 from '@/components/season-2/episode-5.vue'
import Episode6 from '@/components/season-2/episode-6.vue'
export default {
  components: {
    Episode0,
    Episode1,
    Episode2,
    Episode3,
    Episode4,
    Episode5,
    Episode6
  }
}
</script>

<style lang="css">

</style>
